import script from "./InputFormHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputFormHeader.vue?vue&type=script&lang=ts&setup=true"

import "./InputFormHeader.vue?vue&type=style&index=0&id=0707a2fa&scoped=true&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0707a2fa"]])

export default __exports__